module.exports = __webpack_public_path__ + "img/sv86on.b3f87b20.svg";